import React, { ReactNode } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { isDevelopment } from "../../utils/check";
import useToken from "../../hooks/useToken";

interface AuthenticatedProps {
  children: ReactNode;
  fallback?: ReactNode;
}

function Authenticated(props: AuthenticatedProps) {
  const location = useLocation();
  const token = useToken();


  if (isDevelopment() || token) {
    return props.children;
  }

  let redirectUrl =  '/loginOnlineMall';
  if (location.pathname !== '/') {
    redirectUrl = redirectUrl + `?rf=${window.location.href}`;
  }
  const { fallback = <Redirect to={redirectUrl} /> } = props;
  return fallback;
}

Authenticated.defaultProps = {};

export default Authenticated;
